import * as React from 'react';
import styled from 'styled-components';
import { getStoreState } from '../state/Store';

const Name = styled.span`
  display: block;
  font-size: 20px;
  margin-bottom: 3px;
`;

const Email = styled.span`
  opacity: 0.7;
  font-size: 16px;
`;

const Avatar = styled.img`
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 20px;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;

export default class extends React.Component {
  render() {
    const user = getStoreState().app.user;
    return (
      <Wrapper>
        <Avatar
          alt=""
          src={(user && user.photoURL) || '/media/icons/avatar.svg'}
          crossOrigin="anonymous"
          draggable={false}
        />
        <div style={{ textAlign: 'left' }}>
          <Name>{user ? user.displayName || user.email : 'Loading...'}</Name>
          {user && user.displayName && <Email>{user.email}</Email>}
        </div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/account/UserRow.tsx